define(function(require, exports, module) {
    'use strict';

    const AbstractProvider = require('common/addressLookupSwiss/sourceProviders/abstractProvider');

    AbstractProvider.prototype.highlightResult = function(formattedString, inputTxt) {
        const getHighlightedText = (text, highlight) => {
            let groups = highlight.split(' ').map(v => `(${v})`).join('|');
            return '<span>' + text.replace(new RegExp(groups, 'gi'), g => `<span class='highlight'>${g}</span>`) + '<span>';
        };

        return getHighlightedText(formattedString, inputTxt);
    };

    module.exports = AbstractProvider;
});
